import { Insole } from "./Insole";
import PressureData from "../Scan/PressureData";
import { AutoProperties } from "./AutoProperties";
import { User } from "./User";

export class InsoleDesign {
  insoles: Insole[];
  name: string;
  designType: DesignType;
  category: DesignCategory;
  pressureData: PressureData | null;
  autoProperties: AutoProperties | null;
  createdBy: User | null = null;
  printCount: number;
  isSandal: boolean;

  constructor() {
    this.insoles = [];
    this.name = "";
    this.pressureData = null;
    this.autoProperties = null;
    this.designType = DesignType.General;
    this.printCount = 0;
    this.isSandal = false;
    this.category = DesignCategory.Insole;
  }

  static cloneFrom(original: InsoleDesign): InsoleDesign {
    const copy = new InsoleDesign();
    copy.name = original.name;
    copy.designType = original.designType;
    copy.category = original.category;

    copy.insoles = original.insoles.map((ins) => Insole.cloneFrom(ins));
    copy.pressureData = original.pressureData
      ? PressureData.cloneFrom(original.pressureData)
      : null;

    copy.autoProperties = original.autoProperties
      ? AutoProperties.cloneFrom(original.autoProperties)
      : null;

    copy.isSandal = original.category == DesignCategory.Sandal;
    return copy;
  }
  loadFromJson = (jsonData: any) => {
    if ("name" in jsonData) {
      this.name = jsonData.name;
    }
    if ("designType" in jsonData) {
      this.designType = jsonData.designType;
    }
    if ("createdBy" in jsonData && jsonData.createdBy) {
      this.createdBy = new User(jsonData.createdBy);
    }
    if ("printCount" in jsonData) {
      this.printCount = jsonData.printCount;
    }
    if ("category" in jsonData) {
      this.category = jsonData.category;
      this.isSandal = this.category === DesignCategory.Sandal;
    }
  };

  // loadFromJson = async (json: any) => {
  //   this.insoles = [];

  //   const insolePromises = json.insoles.map(async (insoleJson: any) => {
  //     const insole = new Insole();
  //     await insole.loadFromJson(insoleJson);
  //     return insole;
  //   });

  //   this.insoles = await Promise.all(insolePromises);
  // };

  toJSON = () => {
    return {
      insoles: this.insoles.map((insole) => insole.toJSON()),
    };
  };
}

export enum DesignType {
  General = "General",
  Template = "Template",
}

export enum DesignCategory {
  Insole = "Insole",
  Sandal = "Sandal",
  HighHeel = "HighHeel"
}

export const MeshVerticesCount: Record<DesignCategory, number> = {
  [DesignCategory.Insole]: 332,
  [DesignCategory.Sandal]: 587,
  [DesignCategory.HighHeel]: 332
};
